import React from "react";
import PropTypes from "prop-types";
//
import { makeStyles, useTheme } from "@mui/styles";
const useStyles = makeStyles(theme => ({
  container: {
    height: "100vh",
    backgroundPosition: "15%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100vw"
  },
  screenBackgroundPng: {
    backgroundImage: `url(${theme.assets.signinBackground})`
  },
  imageStyle: {
    paddingTop: 12,
    paddingLeft: 12
  },
  [theme.breakpoints.up("sm")]: {
    imageStyle: {
      paddingTop: 24,
      paddingLeft: 24
    },
    container: {
      backgroundPosition: "17%",
      width: "100%"
    }
  },
  [theme.breakpoints.up("md")]: {
    imageStyle: {
      paddingTop: 24,
      paddingLeft: 24
    },
    container: {
      backgroundPosition: "11%"
    },
    "@media (min-height:521px) and (max-height: 800px)": {
      imageStyle: {
        paddingTop: 24,
        paddingLeft: 24
      }
    }
  },
  [theme.breakpoints.up("xl")]: {
    container: {
      backgroundPosition: "0px -2px",
      backgroundSize: "cover"
    }
  }
}));
const LogoLandingContainer = ({
  children
}) => {
  const theme = useTheme();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.container} ${classes.screenBackgroundPng}`
  }, /*#__PURE__*/React.createElement("img", {
    src: theme.assets.logoImg,
    className: classes.imageStyle
  }), children);
};
LogoLandingContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired
};
export default LogoLandingContainer;